export default "__VITE_ASSET__5lZWyAcc__"